import React, { PropTypes } from 'react';
import ImmutablePropTypes from 'react-immutable-proptypes';
import { FormattedMessage } from 'react-intl';

import { bibShape, shelfItemShape, userIdentityShape } from '@bibliocommons/bc-prop-types';
import { Lock } from '@bibliocommons/base-icons';
import BibBrief from '@bibliocommons/shared-bib-brief';
import AvailabilityBibBlock from '@bibliocommons/availability-bib-block';
import ScreenReaderMessage from '@bibliocommons/base-screen-reader-message';
import ItemFormat from '../../../shared/ItemFormat';

import './BibBriefInfo.scss';

function renderAvailabilityInfo(bib, currentLibrary, availabilityDetailActions) {
  const availabilityStatus = bib.get('availability');

  if (bib.get('briefInfo') && availabilityStatus && bib.get('sourceLibId') === currentLibrary.get('id')) {
    return (
      <div className="shelf-availability-info">
        <AvailabilityBibBlock
          bib={bib}
          showAvailabilityLink
          availabilityStatus={availabilityStatus}
          availabilityDetailActions={availabilityDetailActions} />
      </div>
    );
  }

  return null;
}

function renderPrivacyLock(item, owner) {
  if (!item.get('privateItem') || !owner.get('loggedIn')) {
    return null;
  }

  return (
    <span className="privacy-lock">
      <Lock />
      <ScreenReaderMessage>
        <FormattedMessage
          id="item_is_private" />
      </ScreenReaderMessage>
    </span>
  );
}

export default function ShelfListItemBibBriefInfo({ bib, item, owner, currentLibrary, availabilityDetailActions }, context) {
  const briefInfo = bib.get('briefInfo');
  return (
    <div className="cp-shelf-list-item-bib-brief-info">
      <BibBrief bib={briefInfo} renderAuthorsAsLink={!context.mobileApp} renderTitleAsLink={!!briefInfo.get('id')} titleTag="h3" renderIcon={() => renderPrivacyLock(item, owner)}>
        <ItemFormat bib={bib} />
        {renderAvailabilityInfo(bib, currentLibrary, availabilityDetailActions)}
      </BibBrief>
    </div>
  );
}

ShelfListItemBibBriefInfo.propTypes = {
  currentLibrary: ImmutablePropTypes.map.isRequired,
  bib: bibShape.isRequired,
  item: shelfItemShape.isRequired,
  owner: userIdentityShape.isRequired,
  availabilityDetailActions: PropTypes.objectOf(PropTypes.func).isRequired
};

ShelfListItemBibBriefInfo.contextTypes = {
  mobileApp: PropTypes.bool
};



// WEBPACK FOOTER //
// ./app/components/shelves/ShelfListItem/BibBriefInfo/BibBriefInfo.jsx